export const mapIconToGroup = group => {
  switch (group) {
    case 'Students':
      return 'user';
    case 'Administration':
      return 'settings';
    case 'Reports':
      return 'line chart';
    case 'Utilities':
      return 'tasks';
    case 'Serve':
      return 'add';
    default:
      return 'info';
  }
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/icon.js